import React from "react";

/**
 * SPINLOOP-sanamerkki: kursiivi, LOOP brändin oranssilla.
 *
 * LOOP luki ennen teeman korostusväriä (--sl-accent). Kenttä-teema
 * (9.10.2026) vaihtoi sen pallon keltaiseksi, ja logo vaaleni samalla
 * huomaamatta. Logo ei ole teeman väri vaan brändi, joten oranssi on
 * tässä kiinteä — sama kuin sähköpostien logossa (#f4a426).
 *
 * Koko, paksuus ja SPIN-osan väri tulevat ympäröivästä elementistä.
 */
export const LOOP_ORANGE = "#f4a426";

export default function Wordmark() {
  return (
    <span style={{ fontStyle: "italic" }}>
      SPIN<span style={{ color: LOOP_ORANGE }}>LOOP</span>
    </span>
  );
}
